import { ReactElement } from "react";
import { Modal } from "antd";

import { Button } from "@/ui-components/commonComponents/Button/Button";

import "./index.css";

export function BasicModal({
  children,
  isModalOpen,
  handleOk,
  handleCancel,
  autoHeight,
  footer,
  isClosable = true,
  maskStyle,
}: {
  isModalOpen?: boolean;
  children?: ReactElement<any, any>;
  handleOk?: (() => void) | undefined;
  handleCancel?: (() => void) | undefined;
  autoHeight?: boolean;
  footer?: React.ReactNode;
  isClosable?: boolean;
  maskStyle?: React.CSSProperties;
}) {
  return (
    <Modal
      className={!autoHeight ? "modalContainer basicModalContainer" : "basicModalContainer"}
      closable={isClosable}
      maskClosable={isClosable}
      onOk={handleOk}
      onCancel={handleCancel}
      visible={isModalOpen}
      maskStyle={maskStyle}
      footer={
        footer ?? [
          <Button key="cancel" onClick={handleCancel}>
            close
          </Button>,
        ]
      }
    >
      {children}
    </Modal>
  );
}
